module.exports = __webpack_public_path__ + "img/photo-01.950c206c.webp";